<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oZloYf/images/9781439667286.jpg?1684514926539" alt="This image is the cover for the book Western & Atlantic Railroad, Images of Rail"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Western & Atlantic Railroad, Images of Rail
      </h1>
      <p class="bookDescription body article font2">
        <p>The State of Georgia chartered the Western &amp; Atlantic Railroad in 1836. The railroad aided in the development and growth of many communities between Atlanta and Chattanooga, Tennessee. In constructing the railroad, workers created a winding route that cut its way across the North Georgia landscape. During the Civil War, both armies used this vital artery, and it was the setting for one of the war's most iconic events, the Great Locomotive Chase. The state still owns the Western &amp; Atlantic and has leased it since 1870. The line remains an essential part of North Georgia and is a backbone of the region's industry. As Atlanta ponders its transportation future, it is important to remember that without the Western &amp; Atlantic, Atlanta would not be the city it is today.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Todd DeFeo
      </h2>
      
      <p class="authorDescription body article">Todd DeFeo has studied railroads since growing up alongside the Northeast Corridor line in New Jersey. He is editor of Railfanning.org and founder of The DeFeo Groupe. Today, he lives near the historic Western & Atlantic. The images that help make up the visual history in this book come from the many libraries and museums dedicated to preserving the Western & Atlantic's history, the archives of Railfanning.org, and the author's collection.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?26a6453a